<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div style="position: absolute;top:0; bottom: 0;right:0;left:0;background-color: #fafafa">
    <v-row v-if="isShowGrid" style="height: 100%" class="justify-center text-center">
      <v-col v-for="(item,i) in deviceList" v-bind:key="i" class="pa-4 justify-center text-center mx-auto">
        <center>
        <v-img :src="tableUtils.getImage(item)" :lazy-src="tableUtils.getImageThumbUrl(item)" alt="Bild" contain
               :max-height="256"
               :max-width="256"
               style="border: 1px solid #aaa"
               @click="cItem = i;isShowGrid = false;"></v-img>
        </center>
      </v-col>
    </v-row>
    <v-carousel v-else height="100%" hide-delimiters hide-delimiter-background v-model="cItem">
      <v-carousel-item v-for="(item,i) in deviceList" v-bind:key="i">
        <div style="position: absolute;top:28px;right:56px;background-color: transparent;z-index: 111111">
          <v-btn @click="isShowGrid = true;" icon color="#000000" rounded outlined><v-icon>close</v-icon></v-btn>

        </div>

        <div class="media-container">
        <span class="quer" v-if="item.type === 'VIDEO'">
              <video :poster="tableUtils.getImage(item)" :src="tableUtils.getVideoUrl(item)" ref="player" loop autoplay playsinline muted></video>
        </span>
        <v-img v-else :src="tableUtils.getImage(item)" :lazy-src="tableUtils.getImageThumbUrl(item)" alt="Bild" contain
               max-height="100%"
               max-width="100%"
        ></v-img>
        </div>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import Vue from 'vue'
import Sortable from 'sortablejs'

var _ = require('lodash')
var moment = require('moment');
export default {
  name: 'TablePlayListItems',
  components: {},
  methods: {
    pickFile: function () {
      this.$emit('startUpload')
    },
    startUpload: function () {
      this.$emit('startUpload')
    },
    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
      this.currentDevice = item
      this.$refs.dlgLink.open({
        title: 'Netzwerk zuweisen',
        description: 'Wählen Sie ein Netzwerk'
      })
    },
    setDT(a) {
      var d = new Date(a)
      console.log(d.getTime())
    },
    getTimeClass (item) {
      var d1 = new Date(item.activeFrom)
      var d2 = new Date(item.activeTill)
      var d3 = new Date()
      var a = d3.getTime() >= d1.getTime()
      var b = d3.getTime() <= d2.getTime()
      if (a && b){
        return 'pb-0 greenInput'
      } else {
        return 'pb-0 redInput'
      }
    },
    setFrom(item) {
      item.activeFrom = new Date(item.formattedDatetime).getTime()
      console.log(item)
      Vue.prototype.$api.updatePlayListItem(item.guid, item, this.onItemUpdated)
    },
    setFileName(item) {
      Vue.prototype.$api.updatePlayListItem(item.guid, item, this.onItemUpdated)
    },
    setDuration(item) {
      Vue.prototype.$api.updatePlayListItem(item.guid, item, this.onItemUpdated)
    },
    setTill(item) {
      item.activeTill = new Date(item.formattedDatetimeTill).getTime()
      Vue.prototype.$api.updatePlayListItem(item.guid, item, this.onItemUpdated)
    },
    onItemUpdated: function () {
      this.reload(this.playListGuid)
    },
    onLinkCompany: function (item) {
      console.log('onLinkCompany', item)
      Vue.prototype.$api.linkPlayListToCompany(this.currentDevice, item, this.onItemUpdated)
    },
    onLinkPL: function (item) {
      console.log('onLinkPL', item)
      var cmp = this
      Vue.prototype.$api.linkPlayListToPlayList(this.playListGuid, item, function () {
        cmp.reload(cmp.playListGuid)
      })
    },
    getColor: function (item) {
      var css = ''
      var cpl = '#ee0d10'
      if (item.fromPlayList) {
        css += 'color:' + cpl + ';'
      }
      if (item.type === 'PLAYLIST') {
        css += 'color:' + cpl + '; font-weight: bold;'
      }
      return css;
    },
    deleteItem: function (item) {
      var cmp = this
      Vue.prototype.$api.deletePlaylistItem(this.playListGuid, item.guid, function () {
        cmp.reload(cmp.playListGuid)
      })
    },
    editItem: function (item) {
      this.$router.push('/PlaylistItem/' + item.guid)
    },
    addPlayList: function () {
      this.$refs.dlgLinkPL.open()
    },
    addURLItem: function () {
      var newItem = {
        orderNr: 900,
        name: 'Web URL',
        localFileName: 'https://kermax.tv/',
        localAbsoluteFileName: '',
        type: 'WEB',
        mime: 'web',
        size: 0,
        duration: 10,
        md5: '',
        config: '',
        thumb: '',
        active: 0
      }
      var cmp = this
      Vue.prototype.$api.createPlaylistItem(this.playListGuid, newItem, function (data) {
        console.log('data', data)
        cmp.reload(cmp.playListGuid)
      })
    },
    savePlayListSort: function () {
      console.log('savePlayListSort', this.deviceList)
      var idList = []
      for (var i in this.deviceList) {
        var item = this.deviceList[i]
        idList.push(item.id)
      }
      var r = {
        sort: JSON.stringify(idList)
      }
      console.log('savePlayListSort', r)
      Vue.prototype.$api.savePlayListSort(this.playListGuid, r, this.onPlayListSortSaved)
    },
    onPlayListSortSaved: function (res) {
      console.log('onPlayListSortSaved', res)
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: #aa4444;'
      }
      return style
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
          dm = decimals <= 0 ? 0 : decimals || 2,
          sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    reload: function (guid) {
      this.playListGuid = guid
      const auth = "{\"authorized\":true,\"user\":\"Standard\",\"data\":{\"id\":17,\"guid\":\"119e53f0-4058-11ea-a4e7-ddcf11da9536\",\"guidParent\":\"\",\"guidRole\":\"89812-AA-FF-dD-3223d\",\"username\":\"Standard\",\"email\":\"info@edologic.de\",\"forename\":\"Admin\",\"lastname\":\"Admin\",\"phonenumber\":\"+4920294799620?\",\"password\":\"c98d29009ec1aa9cb99a3e490053a47e\",\"created\":\"2020-01-26\",\"companyName\":null,\"roleName\":\"Administrator\",\"role\":\"Administrator\",\"success\":true,\"rights\":{\"RIGHT_COMP_VISIBLE_CHANNELS\":true,\"RIGHT_COMP_VISIBLE_MAILS\":true,\"RIGHT_COMP_VISIBLE_SUPPORT\":true,\"RNETWORK_TAB_COMMENTS_OWN\":true,\"RIGHT_COMP_VISIBLE_MEDIA\":true,\"RIGHT_COMP_STAGE_UPLOAD_PICTURE\":false,\"RIGHT_COMP_STAGE_IMG_VISIBLE\":false,\"RIGHT_COMP_STAGE_CHANNELS_VISIBLE\":false,\"RIGHT_COMP_STAGE_LAST_PING_VISIBLE\":false,\"RIGHT_COMP_STAGE_STATISTIC_VISIBLE\":false,\"RNETWORK_TAB_MEDIA_OWN\":true,\"RIGHT_COMP_VISIBLE_NAVIGATION\":true,\"RIGHT_COMP_VISIBLE_DASHBOARD\":false,\"DASHBOARD_VISIBLE_NETWORK\":true,\"DASHBOARD_VISIBLE_PLAYLIST\":true,\"DASHBOARD_VISIBLE_DEVICES\":true,\"DASHBOARD_VISIBLE_USER\":true,\"RNETWORK_TAB_STAMMDATA_OWN\":true,\"RNETWORK_TAB_USER_OWN\":true,\"RNETWORK_TAB_ROLE_OWN\":true,\"RNETWORK_TAB_PLAYLIST_OWN\":true,\"RNETWORK_TAB_DEVICES_OWN\":true,\"RNETWORK_TAB_LOCATIONS_OWN\":true,\"RIGHT_COMP_VISIBLE_USER\":true,\"RIGHT_COMP_VISIBLE_ROLES\":true,\"RIGHT_COMP_VISIBLE_APPS\":true,\"RIGHT_COMP_VISIBLE_DEVICES\":true,\"RIGHT_COMP_VISIBLE_PLAYLIST\":true,\"RIGHT_COMP_VISIBLE_NETWORK\":true,\"RIGHT_NETWORK_VISIBLE_OTHER\":true,\"RIGHT_NETWORK_OPEN_OTHER\":true,\"RIGHT_NETWORK_DELETE_OTHER\":true,\"RIGHT_NETWORK_DELETE_OWN\":true,\"RIGHT_NETWORK_OPEN_OWN\":true,\"RIGHT_NETWORK_VISIBLE_OWN\":true,\"RIGHT_NETWORK_CREATE\":true}}}"
      if (window.localStorage) {
        window.localStorage.cmCredentials = auth
      }
      Vue.prototype.$api.loadPlayListItems(this.playListGuid, this.onGetData)
    },
    onGetData: function (result) {
      this.deviceList = result
      this.sortArray = _.clone(this.deviceList)
      this.updateCounter()
    },
    updateCounter() {
      var listData = {
        cnt: 1,
        duration: 0,
        size: 0
      }
      for (var index in this.deviceList) {
        var row = this.deviceList[index]
        row.formattedDatetime = moment(row.activeFrom).format("DD.MM.YYYY HH:mm")
        row.formattedDatetimeTill = moment(row.activeTill).format("DD.MM.YYYY HH:mm")
        if (row.active) {
          listData.duration = listData.duration + row.duration * 1
        }
        listData.size = listData.size + row.size
      }
      listData.cnt = this.deviceList.length
      this.$emit('getCount', listData)
    },
    convertToDateTime: function (t) {
      return moment(t).format("DD.MM.YYYY HH:mm")
    },
    onDragEnd: function (evt) {
      var newIndex = evt.newIndex
      var oldIndex = evt.oldIndex
      console.log('', newIndex, oldIndex, this, this.deviceList[0].id)
      while (oldIndex < 0) {
        oldIndex += this.deviceList.length
      }
      while (newIndex < 0) {
        newIndex += this.deviceList.length
      }
      if (newIndex >= this.deviceList.length) {
        let k = newIndex - this.deviceList.length
        while ((k--) + 1) {
          this.items.push(undefined)
        }
      }
      this.deviceList.splice(newIndex, 0, this.deviceList.splice(oldIndex, 1)[0])
      this.sortChanged = true

      var iii = 100
      for (var i in this.deviceList) {
        this.deviceList[i].orderNr = (iii + 1) * 100
        iii++
      }
      console.log('', newIndex, oldIndex, this.deviceList)
    },
    setOrderNr(item) {
      var cmp = this
      console.log('setOrderNr', item)
      Vue.prototype.$api.updatePlayListItem(item.guid, item, function () {
        cmp.reload(cmp.playListGuid)
      })
    },
    changeActive(item) {
      if (item.active === 0) item.active = 1
      if (item.active === 1) item.active = 0
      if (item.readOnly) {
        return
      }
      var cmp = this
      Vue.prototype.$api.updatePlayListItem(item.guid, item, function () {
        cmp.reload(cmp.playListGuid)
        cmp.updateCounter()
      })
    },
    activateDragAndDrop() {
      // window.jQuery(".plTable .v-data-table tbody")
      let table = document.querySelector('.plTable .v-data-table tbody')
      const _self = this
      console.log('activateDragAndDrop', table)
      Sortable.create(table, {
        handle: '.handle',
        onEnd: _self.onDragEnd
      })
    }
  },
  data() {
    return {
      slideModel: [],
      dtpProps: {
        dense: true,
        outlined: true,
        'prepend-icon': 'update',
      },
      dtpProps1: {
        dense: true,
        outlined: true,
        'prepend-icon': 'update',
      },
      currentDevice: null,
      tableUtils: require('@/components/tables/TableUtils').default,
      search: null,
      sortChanged: false,
      sortArray: [],
      colors: ['red', 'blue'],
      colorMap: [],
      headers: [
        {text: 'Sort', value: 'orderNr', width: 80},
        {text: 'Aktiv', value: 'active'},
        {text: 'Icon', value: 'thumb'},
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Sichtbar', value: 'activeFrom'},
        /*{text: 'Erstellt', value: 'created'},*/
        /*{text: 'Remote', value: 'remoteAddress'},*/
        {text: 'Dateigröße', value: 'size'},
        /*{text: 'Type', value: 'type'},*/
        /*{text: 'Kommentar', value: 'comment'},*/
        {text: 'Aktion', value: 'action'}
      ],
      deviceList: [],
      cItem: 0,
      isShowGrid: true,
    }
  },
  mounted() {

    this.reload(this.$route.params.guid)
  }
}
</script>

<style scoped>
.media-container {
  /* Füllt den gesamten Platz des Carousel-Slides */
  height: 100%;
  width: 100%;

  /* Zentriert Inhalt horizontal & vertikal */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Damit das Video nicht oben „klebt“ und sich anpasst */
.media-container video {
  max-width: 100%;
  max-height: 100%;
  /* Optional: object-fit (wird nicht von allen Browsern bei <video> unterstützt) */
  /* object-fit: contain; */
  display: block;
}

/* Verhindert das Start-Icon */
video::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none;
}

/* Generell alle Controls verbergen (wenn controls="" doch im Code steht) */
video::-webkit-media-controls {
  display: none !important;
}

</style>
